import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { ImageFromDirectusProps } from './ImageFromDirectusProps';

export const ImageFromDirectus: React.FC<ImageFromDirectusProps> = ({
	image,
	alt,
	imageClassName,
}) => {
	return (
		<>
			{typeof image === 'string' ? (
				<img
					src={image}
					alt={alt}
					loading="lazy"
					className={imageClassName ? imageClassName : ''}
				/>
			) : (
				<GatsbyImage image={image} alt={alt} />
			)}
		</>
	);
};
